import { Navigate, useLocation } from '@faceup/router'

/**
 * Catch-all for the unauthenticated route tree: sends the visitor to the login page while
 * keeping the URL they asked for in `?fallback=`, so login can return them there.
 */
export const LoginRedirect = () => {
  const location = useLocation()

  return <Navigate replace to={routes => routes.login({ fallback: location })} />
}
